<div class="export-process-snack">
    <div class="process-icon">
    <mat-icon class="process-flask" fontSet="fas" fontIcon="fa-flask"></mat-icon>
    <mat-icon class="process-gear" fontSet="fas" fontIcon="fa-cog"></mat-icon>
    </div>

  <div class="content">
    <div class="message">{{ data.messageKey ? (data.messageKey | transloco) : ('documentSearch.exportProcessSnack.preparingMsg' | transloco: { processName: data.processName || ('documentSearch.exportProcessSnack.yourDocumentsLbl' | transloco) }) }}</div>
    <button type="button" class="progress-button" (click)="viewProgress()">{{ 'documentSearch.exportProcessSnack.viewProgressBtn' | transloco }}</button>
  </div>

  <button type="button" class="close-button" (click)="close()">×</button>
</div>